<template src="./unitTypeDetail.template.html"></template>
<script>
    import * as axios from "axios";
    import $ from "jquery";
    import moment from "moment-timezone";

    export default {
        // options
        name: "UnitTypeDetail",
        props: ["unitTypeId"],
        data() {
            return {
                apiUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : ""),
                statusList: [],
                statusId: 1,
                unitTypeStatus: {
                    StatusId: 1,
                    StatusName: "Active"
                },
                displaySectionValue: "unitTypeInfo1",
                unitTypeData: {},
                unitList: [],
                imageData: [],
                imageArr: [],
                index: null,
                imgs: [],
                visible: false,
                isBgColor9: false,
                paymentAccountList: [],
                CommissionAmount: null,
                commissionPercent: null,
                commissionPercentColor: null,
                editDefault: true,
                syncMethodsList: [
                    {
                        method: "Inventory",
                        IsChecked: true
                    },
                    {
                        method: "Rates",
                        IsChecked: true
                    },
                    {
                        method: "Restrictions",
                        IsChecked: true
                    }
                ],
                integrationChannels: {},
                customFieldsList: [{}],
                showLovList: false,
                selectedLovDropdown: null,
                componentIntegrationId: null,
                listOfIntegrations: [],
                showIntegrationScreen: true,
                ruClientAccountList: [],
                unitConnectedRuAccount: [],
                unitClassList: [],
                propertyList: [],
                crsUnitClass: [],
                actualUnitClassList: [],
                wheelHouseUserList: [],
                selectedIntgratedIds: null,
                AminitiesData: [],
            };
        },

        methods: {
            saveAmenitiesData() {
                let vm = this;
                if (vm.unitID === -1) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "please enter Unittype Details",
                    });
                } else {
                    vm.checkedAminities = [];
                    if (vm.AminitiesData && vm.AminitiesData.length > 0) {
                        for (
                            let AminitiesDataIndex = 0;
                            AminitiesDataIndex < vm.AminitiesData.length;
                            AminitiesDataIndex++
                        ) {
                            if (Number(vm.AminitiesData[AminitiesDataIndex]["IsChecked"])) {
                                console.log(
                                    "ami name ====>>",
                                    vm.AminitiesData[AminitiesDataIndex].ListName
                                );
                                vm.checkedAminities.push(
                                    vm.AminitiesData[AminitiesDataIndex]["ListId"]
                                );
                            }
                        }
                        vm.$store.dispatch("dataRequestHandler", {
                            key: "AddUnitDetail",
                            params: {
                                section: "saveUnitInformation7",
                                UnitId: vm.unitTypeData.UnitTypeId,
                                checkedAminities: vm.checkedAminities,
                                // IsSync: vm.unitData.IsSync,
                                PropertyId: vm.unitTypeData.PropertyId,
                            },
                            callback: function (error, response) {
                                console.log("unittype ame1 response", response);
                                if (error) {
                                    console.error("Error has occured => ", error);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        header: "Amenities  Error!",
                                        message: error.sqlMessage ? error.sqlMessage : error,
                                    });
                                    return;
                                } else {
                                    // var clientIdURL = response.recordsets[2][0].ClientId;
                                    vm.section7val = true;
                                    vm.$store.dispatch("toastr", {
                                        type: "success",
                                        header: "Success!",
                                        message: "Amenities  successfully saved",
                                    });

                                    vm.Get_UnitTypeDetail();
                                }
                                // vm.unitID = response.recordsets[1][0].UnitId;
                                // let PropertyId = response.recordsets[1][0].PropertyId;
                                // console.log("checking unitId", vm.unitID);
                                // console.log("checking PropertyId", PropertyId);
                                // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
                            },
                        });
                    }
                }
            },
            AmenitySave(e, Aminity) {
                if (e.target.checked) {
                    return;
                } else {
                    var index = this.AminitiesData.indexOf(Aminity);
                    this.AminitiesData[index].IsChecked = 0;
                    var index2 = this.AminitiesData.indexOf(Aminity.ListId);
                    if (index2 > -1) {
                        this.checkedAminities.splice(index2, 1);
                    }
                    console.log(
                        "checked amineties========>",
                        JSON.stringify(this.AminitiesData)
                    );
                    console.log("checkedAminities=>", this.checkedAminities);
                }
            },
            wheelHouseUserListData(wheelhousedata) {
                let vm = this;
                vm.wheelHouseUserList.splice(0, vm.wheelHouseUserList.length, ...wheelhousedata);
                vm.selectedIntgratedIds = vm.wheelHouseUserList
                    .filter((val) => val.IntegrationId === 5 || val.IntegrationId === 6)
                    .map((item) => item.IntegrationId);
                console.log("selectedIntgratedIds----", vm.selectedIntgratedIds);
            },
            activateUnitandCrsPropertyMapping(ruIntegarationscreen, rentalUnitedClient) {
                let vm = this;
                rentalUnitedClient =
                    rentalUnitedClient && rentalUnitedClient.UserName
                        ? rentalUnitedClient
                        : vm.selectedRuClientAccountList;
                if (
                    vm.unitConnectedRuAccount.length > 0 &&
                    rentalUnitedClient.UserName != vm.unitConnectedRuAccount[0].UserName &&
                    rentalUnitedClient.IntegrationId == 1
                ) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "warning!",
                        message:
                            "Can not push data to ru due to unit type is mapped with other RU account",
                    });
                    return;
                }

                // let selectedRUAccount = vm.ruClientAccountList.filter(ruaccount => ruaccount.IsDefault && ruaccount.StatusId == 1)
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_CrsPropertyDetails",
                    params: {
                        CrsId: 2,
                        UnitId: vm.unitTypeData.UnitTypeId,
                        IsActive: vm.unitTypeData.StatusId == 1 ? true : false,
                        PropertyId: vm.crsPropertyId
                            ? vm.crsPropertyId
                            : rentalUnitedClient.CrsPropertyId,
                        username: rentalUnitedClient.UserName,
                        Password: rentalUnitedClient.Password,
                        CrsResponse: null,
                        MessageId: null,
                        ruIntegarationscreen: ruIntegarationscreen ? true : false,
                        ownerId: vm.crsOwnerId ? vm.crsOwnerId : rentalUnitedClient.OwnerId, //RUproperty.CrsOwnerId
                    },
                    callback: function (error, response) {
                        console.log("Save_CrsPropertyDetails response", response);
                        if (error) {
                            if (vm.unitTypeData.StatusId == 1) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Unable to activate",
                                    header: "Error!",
                                });
                            }
                            return;
                        }
                        if (vm.unitTypeData.StatusId == 1) {
                            if (
                                response[0] &&
                                response[0].length > 0 &&
                                response[0][0].ErrorMessage &&
                                response[0][0].ErrorMessage.trim() != ""
                            ) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Unable to activate",
                                    header: "Error!",
                                });
                            } else {
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    message: "Success!",
                                    header: "Activated Successfully",
                                });
                                vm.loadUnitDetails(rentalUnitedClient);
                            }
                        }
                    },
                });
            },
            deleteUnitSyncDetails(rentalUnitedClient) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "deleteUnitSyncDetails",
                    params: {
                        UnitId: vm.unitTypeData.UnitTypeId,
                        fromMapping: 1,
                        rentalUnitedClient: rentalUnitedClient,
                        crsPropertyId: vm.unitTypeData.CrsPropertyId,
                    },
                    callback: function (error, response) {
                        console.log("deleteUnitSyncDetails response", response);
                        if (error) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                message: "Unable to InActivate",
                                header: "Error!",
                            });
                            return;
                        }
                        if (
                            response[0] &&
                            response[0].length > 0 &&
                            response[0][0].ErrorMessage
                        ) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                message: "Unable to InActivate",
                                header: "Error!",
                            });
                        } else {
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                message: "InActivated Successfully",
                                header: "Success!",
                            });
                            vm.integrationChannels.IsUnitMapped = false;
                            vm.loadUnitDetails(rentalUnitedClient);
                        }
                    },
                });
            },
            loadUnitDetails(rentalUnitedClient) {
                var vm = this;
                vm.Get_UnitTypeDetail();
                if (rentalUnitedClient) {
                    vm.$refs.RUIntegration.pullPropertyList(rentalUnitedClient);
                }
                vm.$refs.RUIntegration.getRentalUnitedClients();
            },
            activeClass(integrationName) {
                return this.integrationName === integrationName;
            },
            getRentalUnitedClients(unitTypeId) {
                var vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        PropertyId: null,
                        UnitId: unitTypeId ? unitTypeId : vm.unitTypeData.UnitTypeId,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Error in Get_ListOfIntegrations_RU => ", err);
                            return;
                        }
                        if (response) {
                            console.log("response in Get_ListOfIntegrations_RU", response);
                            vm.ruClientAccountList.splice(
                                0,
                                vm.ruClientAccountList.length,
                                ...response[0]
                            );
                            console.log("vm.ruClientAccountList", vm.ruClientAccountList);
                            vm.unitConnectedRuAccount = vm.ruClientAccountList.filter(
                                (ruaccount) =>
                                    ruaccount.CrsStatus == 3 && ruaccount.IntegrationId == 1
                            );
                            console.log("vm.unitConnectedRuAccount", vm.unitConnectedRuAccount);
                        }
                    },
                });
            },
            Get_ListOfIntegrations() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations",
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        } else {
                            console.log("response in Get_ListOfIntegrations", response);
                            vm.listOfIntegrations = response[0];
                            // vm.listOfIntegrations.push(testObj)          //Need to remove,Temporary used
                        }
                    },
                });
            },
            showSidePanel(integrationId, integration) {
                let vm = this;
                vm.displaySection("syncToRU");
                vm.selectedIntegration = integration;
                vm.componentIntegrationId = integrationId;
            },
            syncUnitToRU(unitTypeData, rentalUnitedClient) {
                let vm = this;
                let selectedRU = vm.ruClientAccountList.filter(
                    (ruaccount) => ruaccount.IsDefault == true
                );
                rentalUnitedClient = rentalUnitedClient
                    ? rentalUnitedClient
                    : selectedRU[0];
                if (
                    unitTypeData == "Property Sync" &&
                    rentalUnitedClient &&
                    typeof rentalUnitedClient == "object"
                ) {
                    if (
                        vm.unitConnectedRuAccount.length > 0 &&
                        rentalUnitedClient.UserName !=
                        vm.unitConnectedRuAccount[0].UserName &&
                        rentalUnitedClient.IntegrationId == 1
                    ) {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "warning!",
                            message:
                                "Can not push data to ru due to unittype is mapped with other RU account",
                        });
                        return;
                    }
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "syncUnitToRU",
                    params: {
                        UnitId: vm.unitTypeData.UnitTypeId,
                        // CrsPropertyId: vm.crsPropertyId,
                        MessageType: unitTypeData,
                        CrsId: rentalUnitedClient.CrsId,
                        rentalUnitedClient: rentalUnitedClient,
                        PropertyId: vm.unitTypeData.PropertyId,
                    },
                    callback: function (error, response) {
                        console.log("unit1 response", response);
                        if (unitTypeData == "Property Sync") {
                            if (response && response.PropertyId != -1) {
                                // vm.crsPropertyId = response.PropertyId;
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Unit type sync successfull",
                                });
                                vm.integrationChannels.IsUnitMapped = true;
                                vm.Get_UnitTypeDetail();
                                if (
                                    rentalUnitedClient &&
                                    typeof rentalUnitedClient == "object" &&
                                    rentalUnitedClient.CrsId == 2
                                ) {
                                    vm.$refs.RUIntegration.pullPropertyList(rentalUnitedClient);
                                    vm.$refs.RUIntegration.getRentalUnitedClients();
                                }
                                vm.getRentalUnitedClients(vm.unitTypeData.UnitId);
                            } else {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "warning!",
                                    message: "Unit type sync failed ",
                                });
                            }
                        }
                        if (unitTypeData == "Rates") {
                            if (response && response.message == "Success") {
                                // vm.crsPropertyId = response.PropertyId;
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Rates sync successfull",
                                });
                            } else if (response && response.message) {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "warning!",
                                    message: "Rates sync failed " + response.message,
                                });
                            }
                        }
                        if (unitTypeData == "Inventory") {
                            if (response && response.message == "Success") {
                                // vm.crsPropertyId = response.PropertyId;
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Inventory sync successfull",
                                });
                            } else if (response && response.message) {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "warning!",
                                    message: "Inventory sync failed " + response.message,
                                });
                            }
                        }
                        if (unitTypeData == "Restrictions") {
                            if (response && response.message == "Success") {
                                // vm.crsPropertyId = response.PropertyId;
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Restrictions sync successfull",
                                });
                            } else if (response && response.message) {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "warning!",
                                    message: "Restrictions sync failed " + response.message,
                                });
                            }
                        }
                    },
                });
            },
            syncUnitDetailsToRU(ruSyncMethodsList, rentalUnitedClient) {
                let vm = this;
                let ruSyncMethods = ruSyncMethodsList.filter(
                    (col) => col.IsChecked == true
                );
                let syncMethods = ruSyncMethods.map((obj) => obj.method);
                console.log("ruSyncMethods===>", syncMethods);
                for (let method of syncMethods) {
                    vm.syncUnitToRU(method, rentalUnitedClient);
                }
            },
            editDefaultValue(e) {
                let vm = this;
                if (e.target.checked) {
                    vm.unitTypeData.UseDefault = 1;
                    // vm.getClientDetailByid();
                    //CommissionAmount: null,
                    //commissionPercent: null
                    vm.CommissionAmount = vm.unitTypeData.DefaultCommissionAmount;
                    vm.commissionPercent = vm.unitTypeData.DefaultCommissionType;
                    if (vm.commissionPercent == true) {
                        vm.commissionPercent = 1;
                    } else if (vm.commissionPercent == false) {
                        vm.commissionPercent = 0;
                    }
                    vm.editDefault = true;
                } else {
                    vm.unitTypeData.UseDefault = 0;
                    vm.editDefault = false;
                    vm.CommissionAmount = vm.unitTypeData.CommissionAmount;
                    vm.commissionPercent = vm.unitTypeData.IsPercent;
                    if (vm.commissionPercent == true) {
                        vm.commissionPercent = 1;
                    } else if (vm.commissionPercent == false) {
                        vm.commissionPercent = 0;
                    }
                }
            },
            changeInCommisssion() {
                let vm = this;
                vm.commissionPercentColor = "yellowColor";
            },
            makePaymentAccountDefault(paymentAccount) {
                let vm = this;
                let classsName = "#" + this.paymentAccountEdit;
                $(classsName).removeClass("show");
                paymentAccount.IsDefault = true;
                vm.Update_Acc_Commission_Config(paymentAccount);
            },
            removePaymentAccount(paymentAccount, statusId) {
                let vm = this;
                let classsName = "#" + this.paymentAccountEdit;
                $(classsName).removeClass("show");
                paymentAccount.StatusId = statusId;
                paymentAccount.IsDefault = false;
                vm.Update_Acc_Commission_Config(paymentAccount);
            },
            Update_Acc_Commission_Config(paymentAccount) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Update_Acc_Commission_Config",
                    params: {
                        ModuleAction: "Update_Acc_Commission_Config",
                        propertyId: vm.unitTypeData.PropertyId,
                        unitId: null,
                        isClient: true,
                        paymentAccount: paymentAccount,
                        CommissionPercent: vm.commissionPercent,
                        CommissionAmmount: vm.CommissionAmount,
                        UseDefault: vm.unitTypeData.UseDefault,
                        IsLive: vm.IsLive == true ? 1 : 0,
                        UnitTypeId: vm.unitTypeData.UnitTypeId

                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            if (response[0] && response[0].length > 0 && response[0][0].ErrorMessage) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Error!",
                                    header: "unable to update"
                                });
                            } else {
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    message: "Updated the account successfully",
                                    header: ""
                                });
                                vm.Get_PaymentAccount_Details();
                                vm.Get_UnitTypeDetail();
                            }
                            console.log("response in Get_PaymentAccount_Details", response);
                        }
                    }
                });
            },
            Get_PaymentAccount_Details() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_PaymentAccount_Details",
                    params: {
                        ModuleAction: "Get_PaymentAccount_Details",
                        propertyId: vm.unitTypeData.PropertyId,
                        unitId: null,
                        isClient: true,
                        IsActive: vm.IsActive,
                        UnitTypeId: vm.unitTypeData.UnitTypeId
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("response in Get_PaymentAccount_Details", response);
                            vm.paymentAccountList.splice(
                                0,
                                vm.paymentAccountList.length,
                                ...response[2]
                            );
                            vm.IsLive = response[3][0].IsLive;
                        }
                    }
                });
            },
            createUpdateImage(file, ImageId) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = e => {
                    // vm.image = e.target.result;
                    // vm.propertyData.propertyContent.PropertyLogo = vm.image;

                    // console.log("image===================>", vm.image);
                    // vm.imageArr.push(vm.image);
                    const formData = new FormData();
                    Array.from(Array(this.imageData.length).keys()).map(x => {
                        formData.append("photos", this.imageData[x], this.imageData[x].name);
                    });
                    console.log(this.apiUrl + "/upload");
                    let url = this.apiUrl + "/upload";
                    // let obj = {};
                    // obj.ImageUrl = e.target.result;
                    // obj.ImageId = -1;

                    // vm.imageArr.push(obj);

                    axios.post(url, formData).then(data => {
                        // console.log(data.data, data.data.length);

                        // console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
                        let obj = {};
                        obj.ImageId = ImageId;
                        obj.ImageUrl = data.data[0].imageGuid;

                        let imageIndex = vm.imageArr.findIndex(x => x.ImageId == ImageId);
                        vm.imageArr[imageIndex] = obj;
                        vm.removeImage(obj.ImageUrl, imageIndex, false);

                        // vm.saveImages()
                        // vm.imageData.splice(0, vm.imageData.length);

                        // for (let img of data.data) {

                        //   let obj = {};
                        //   obj.ImageUrl = img.imageGuid;
                        //   obj.ImageId = -1;

                        //   vm.imageData.push(obj);
                        // }
                        console.log(vm.imageArr);
                        // vm.saveImages();
                    });
                };
                reader.readAsDataURL(file);
            },
            getImageId(id) {
                this.selectedImageId = id;
            },
            upDateimg(e) {
                // console.log("ImageIdImageId",ImageId);
                let files = e.target.files || e.dataTransfer.files;
                this.imageData.push(files[0]);
                if (!files.length) {
                    //update image
                    this.unitTypeData.UnitLogo = null;
                    return;
                } else {
                    this.createUpdateImage(files[0], this.selectedImageId);
                }
            },
            removeImage(imageGuid, index, isdelete) {
                console.log("imagesimages", imageGuid);
                let vm = this;
                // console.log("vm.imageArr[index]",vm.imageArr[index].ImageId);
                vm.$store.dispatch("dataRequestHandler", {
                    key: "DeleteImages",
                    params: {
                        ModuleAction: "deleteImages",
                        ImageId: vm.imageArr[index].ImageId,
                        ImageUrl: vm.imageArr[index].ImageUrl,
                        isdelete: isdelete
                    },
                    callback: function (err, response) {
                        console.log("image call back==>", response);
                        if (err) {
                            console.error("Error has occured => ", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "error!",
                                message: error.sqlMessage ? error.sqlMessage : err
                            });
                            return;
                        } else if (response[0][0] && response[0][0].isEdited === true) {
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "successfully image updated"
                            });
                        } else {
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "successfully image deleted"
                            });
                        }

                        vm.getImages();
                    }
                });
            },
            imageUrls(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
            },
            getImages: function () {
                let scope = this;
                let property_temp_URL = null;
                let UnitURLId = null;
                let PropertyURLId = null;
                console.log("In view unit type detail" + this.$route.params.propertyId);
                property_temp_URL = this.$route.params.unitTypeId;
                if (property_temp_URL < 0) {
                    UnitURLId = -1;
                    PropertyURLId = property_temp_URL.replace("-", "");
                    console.log("In if loop" + UnitURLId + PropertyURLId);
                    this.unitTypeData.PropertyId = PropertyURLId;
                    scope.isDisabled = true;
                } else {
                    UnitURLId = property_temp_URL.replace("+", "");
                    PropertyURLId = null;
                    console.log("In else loop" + UnitURLId + PropertyURLId);
                    scope.isDisabled = true;
                }

                this.$store.dispatch("dataRequestHandler", {
                    key: "GetImages",
                    params: {
                        ModuleAction: "GetImages",
                        UnitId: UnitURLId,
                        PropertyId: scope.$route.params.propertyId,
                        BE_Id: null
                    },
                    callback: function (err, response) {
                        if (response) {
                            console.log("response of get Images", response);
                            // if (response.ImgUrls && response.ImgUrls !== null) {
                            //   scope.imageArr = response.ImgUrls;s

                            // }
                            if (response.recordsets[0] && response.recordsets[0] !== null) {
                                scope.imageArr = response.recordsets[0];
                            } else if (response.recordsets === null) {
                                scope.imageArr = [];
                            }
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            saveImages(imageArr) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "saveAWS_Image",
                    params: {
                        ModuleAction: "saveAWS_Image",
                        propertyId: vm.unitTypeData.PropertyId,
                        images: vm.imageData,
                        UnitId: vm.unitTypeData.UnitTypeId,
                        BE_Id: null
                    },
                    callback: function (error, response) {
                        if (error) {
                            console.error("Error has occured => ", error);

                            return;
                        } else {
                            // console.log(params);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Image successfully saved"
                            });
                            vm.getImages();
                        }
                    }
                });
            },
            handleHide() {
                this.visible = false;
            },
            uploadImages(e) {
                let vm = this;
                if (vm.unitTypeData.UnitTypeId === -1) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "can't upload  until first section details get saved"
                    });
                } else {
                    this.imageData = [];
                    let files = e.target.files || e.dataTransfer.files;
                    this.imageData.push(files[0]);
                    if (!files.length) {
                        this.unitTypeData.UnitLogo = null;
                        return;
                    } else {
                        this.createImage(files[0]);
                    }
                }
            },
            createImage(file) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = e => {
                    vm.image = e.target.result;
                    // vm.unitTypeData.UnitLogo = vm.image;

                    // console.log("image===================>", vm.image);
                    // vm.imageArr.push(vm.image);
                    console.log("vm.imageArr", vm.imageArr);
                    const formData = new FormData();
                    Array.from(Array(this.imageData.length).keys()).map(x => {
                        formData.append("photos", this.imageData[x], this.imageData[x].name);
                    });
                    console.log(this.apiUrl + "/upload");
                    let url = this.apiUrl + "/upload";
                    let obj = {};
                    obj.ImageUrl = vm.image;
                    obj.ImageId = -1;

                    vm.imageArr.push(obj);

                    // console.log("base64" + vm.propertyImages);
                    axios.post(url, formData).then(data => {
                        console.log(data.data, data.data.length);
                        // vm.imageArr.splice(-1, data.data.length);
                        console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
                        vm.imageData.splice(0, vm.imageData.length);

                        for (let img of data.data) {
                            // vm.imageArr.push(apiUrl + '/downloadImage/'+img.imageGuid)
                            let obj = {};
                            obj.ImageUrl = img.imageGuid;
                            obj.ImageId = -1;
                            // vm.imageArr.splice(-1,1);
                            //vm.imageArr.push(obj);
                            vm.imageData.push(obj);
                        }
                        console.log(vm.imageArr);
                        vm.saveImages();
                    });
                };
                reader.readAsDataURL(file);
            },
            show(index) {
                let scope = this;
                scope.imgs = [];
                scope.index = index;
                scope.visible = true;
                for (var x in scope.imageArr) {
                    scope.imgs.push(this.apiUrl + "/downloadImage/" + scope.imageArr[x].ImageUrl + "/null");
                }
            },
            getPropertyMetaData: function () {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertiesBySearchText",
                    params: {},
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("GetPropertiesBySearchText==>", response);
                            vm.statusList.splice(0, vm.statusList.length, ...response.statusList);
                            vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
                        }
                    }
                });
            },
            displaySection(displaySectionValue) {
                let vm = this;
                vm.displaySectionValue = displaySectionValue;
            },
            updateStartSaleDate(key, dateObj, thisObj) {
                let vm = this;
                vm.unitTypeData.StartSaleDate = dateObj
                    ? dateObj.format("DD MMM YYYY")
                    : null;
                console.log("vm.unitTypeData.StartSaleDate", vm.unitTypeData.StartSaleDate);
            },
            updateEndSaleDate(key, dateObj, thisObj) {
                let vm = this;
                vm.unitTypeData.EndSaleDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
                console.log("vm.unitTypeData.EndSaleDate", vm.unitTypeData.EndSaleDate);
            },
            saveUnitTypeInfo() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitTypeInfo",
                    params: {
                        ModuleAction: "Save_UnitTypeInfo",
                        unitTypeData: vm.unitTypeData,
                        statusId: vm.unitTypeStatus ? vm.unitTypeStatus.StatusId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in saveUnitTypeInfo", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In saving unit type"
                            });
                        }
                        if (response) {
                            console.log("response of saveUnitTypeInfo", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Unit Type saved successfully"
                            });
                            if (response[1] && response[1][0] && response[1][0].UnitTypeId && response[1][0].PropertyId) {
                                vm.$router.push("/unitTypeDetail/" + response[1][0].UnitTypeId + "/" + response[1][0].PropertyId);
                                vm.unitTypeData.UnitTypeId = response[1][0].UnitTypeId;
                                vm.unitTypeData.PropertyId = response[1][0].PropertyId;
                                vm.Get_UnitTypeDetail();
                            }
                            for (let ruaccount of vm.ruClientAccountList) {
                                if (ruaccount.CrsStatus == 3) {
                                    if (vm.Unit_Status.StatusId != 1) {
                                        vm.activateUnitandCrsPropertyMapping(true, ruaccount);
                                    } else {
                                        vm.syncUnitToRU("Property Sync", ruaccount);
                                    }
                                }
                            }
                        }
                    }
                });
            },
            saveUnitTypeDescription() {
                let vm = this;
                if (vm.unitTypeData.UnitTypeId == null || vm.unitTypeData.UnitTypeId == -1 || vm.unitTypeData.UnitTypeId == undefined) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please save unit type info"
                    });
                    return;
                }
                if (!vm.unitTypeData.Description) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please fill the description field"
                    });
                    return;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitType_Desc",
                    params: {
                        ModuleAction: "Save_UnitType_Desc",
                        unitTypeData: vm.unitTypeData
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in saveUnitTypeDec", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In saving unit type description"
                            });
                        }
                        if (response) {
                            console.log("response of saveUnitTypeDec", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Unit Type Description saved successfully"
                            });
                            vm.Get_UnitTypeDetail();
                        }
                    }
                });
            },
            saveUnitTypeData() {
                let vm = this;

                if (vm.unitTypeData.MaxSellable && vm.unitTypeData.MaxSellable <= vm.unitList.length) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "Max Sellable should be greater than the number of units"
                    });
                    return;
                }
                if (vm.unitTypeData.UnitTypeId == null || vm.unitTypeData.UnitTypeId == -1 || vm.unitTypeData.UnitTypeId == undefined) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please save unit type info"
                    });
                    return;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitType_MiscInfo",
                    params: {
                        ModuleAction: "Save_UnitType_MiscInfo",
                        unitTypeData: vm.unitTypeData
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Save_UnitType_MiscInfo", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In saving unit type  Info"
                            });
                        }
                        if (response) {
                            console.log("response of Save_UnitType_MiscInfo", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Unit Type  Info saved successfully"
                            });
                            vm.Get_UnitTypeDetail();
                        }
                    }
                });
            },
            saveUnitTypeCapacity() {
                let vm = this;
                if (vm.unitTypeData.UnitTypeId == null || vm.unitTypeData.UnitTypeId == -1 || vm.unitTypeData.UnitTypeId == undefined) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please save unit type info"
                    });
                    return;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitType_Occupancy",
                    params: {
                        ModuleAction: "Save_UnitType_Occupancy",
                        unitTypeData: vm.unitTypeData
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Save_UnitType_Occupancy", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                // message: "In saving unit type capacity"
                                message: `${err}`
                            });
                        }
                        if (response) {
                            console.log("response of Save_UnitType_Occupancy", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Unit Type capacity saved successfully"
                            });
                            vm.Get_UnitTypeDetail();
                        }
                    }
                });
            },
            getunitclassByproperty() {
                let scope = this;
                if (scope.unitTypeData.PropertyId) {
                    let selectedPropertyUnitclass = scope.actualUnitClassList.filter(
                        (unitclss) => unitclss.PropertyId == scope.unitTypeData.PropertyId
                    );
                    scope.unitClassList.splice(0, scope.unitClassList.length, ...selectedPropertyUnitclass);

                    console.log("scope.actualUnitClassList grt by property= ", scope.actualUnitClassList);
                    if (scope.unitClassList.length > 0 && scope.ruPropertyObj) {

                        const selectedCrsUnitclass = scope.crsUnitClass.filter(
                            (crsUnitCls) => crsUnitCls.PropertyTypeId == scope.ruPropertyObj.crsPropertyTypeId);

                        const resultobjval = scope.unitClassList.filter(
                            (selectedUnitCls) =>
                                selectedUnitCls.OTAPropertyType.trim() ==
                                selectedCrsUnitclass[0].ListType &&
                                selectedUnitCls.PropertyId == scope.unitTypeData.PropertyId
                        );
                        scope.unitTypeData.UnitClassId = resultobjval[0].UnitClassId;
                        console.log("resultobjval", resultobjval[0]);
                    }
                }

            },
            Get_UnitTypeDetail() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_UnitTypeDetail",
                    params: {
                        ModuleAction: "Get_UnitTypeDetail",
                        unitTypeId: vm.$route.params.unitTypeId,
                        propertyId: vm.$route.params.propertyId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Get_UnitTypeDetail", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In getting unit type detail"
                            });
                        }
                        if (response) {
                            console.log("response of Get_UnitTypeDetail", response);
                            vm.actualUnitClassList = JSON.parse(JSON.stringify(response[4]));
                            vm.AminitiesData.splice(0, vm.AminitiesData.length, ...response[6]);
                            // vm.unitClassList = response[4];
                            vm.crsUnitClass = response[5];
                            if (response[2] && response[2][0]) {
                                // vm.$store.dispatch("toastr", {
                                //     type: "success",
                                //     header: "Success!",
                                //     message: "Unit type detail rendered successfully"
                                // });
                                vm.unitTypeData = response[2][0];
                                vm.unitTypeStatus.StatusId = vm.unitTypeData.StatusId
                                vm.unitTypeStatus.StatusName = vm.unitTypeData.StatusName
                                vm.showIntegrationScreen = vm.unitTypeStatus.StatusId == 1 ? true : false;

                                if (response[3] && response[3][0]) {
                                    vm.integrationChannels = response[3][0]
                                }

                                if (
                                    vm.unitTypeData.IsPercent == null ||
                                    vm.unitTypeData.IsPercent == false
                                ) {
                                    vm.unitTypeData.IsPercent = 0;
                                } else if (vm.unitTypeData.IsPercent == true) {
                                    vm.unitTypeData.IsPercent = 1;
                                }
                                vm.unitTypeData.StartSaleDate = vm.unitTypeData.StartSaleDate ? moment(
                                    vm.unitTypeData.StartSaleDate
                                ).format("DD MMM YYYY") : null;
                                vm.unitTypeData.EndSaleDate = vm.unitTypeData.EndSaleDate ? moment(
                                    vm.unitTypeData.EndSaleDate
                                ).format("DD MMM YYYY") : null;
                                vm.commissionPercent = vm.unitTypeData.IsPercent;
                                vm.CommissionAmount = vm.unitTypeData.CommissionAmount;
                                if (vm.unitTypeData.UseDefault == 1) {
                                    vm.editDefault = true;
                                } else {
                                    vm.editDefault = false;
                                }
                                console.log("response in imageArr", response.ImgUrls);
                                // if (response.ImgUrls && response.ImgUrls !== null) {
                                //   scope.imageArr = response.ImgUrls;

                                // }
                                // else if (response.ImgUrls === null) {
                                //   scope.imageArr = [];
                                // }

                                // scope.imageArr = response.ImgUrls;
                                vm.commissionPercentColor = null;
                                vm.Get_UnitsAssociated_ToUnitType();
                                vm.Get_PaymentAccount_Details();
                            }
                            if (vm.unitTypeData.PropertyId && vm.unitTypeData.PropertyId != -1 && vm.unitTypeData.PropertyId != -99) {
                                let selectedPropertyUnitclass = vm.actualUnitClassList.filter((unitcls) => unitcls.PropertyId == vm.unitTypeData.PropertyId);
                                vm.unitClassList.splice(0, vm.unitClassList.length, ...selectedPropertyUnitclass);

                                vm.ruPropertyObj = vm.$store.getters.getpullRUSpecProp;
                                vm.selectedRuClientAccountList = vm.$store.getters.getpullRUSpecProp ? vm.$store.getters.getpullRUSpecProp.rentalUnitedClient : [];
                                if (vm.ruPropertyObj && Object.keys(vm.ruPropertyObj).length > 0) {
                                    vm.crsOwnerId = vm.ruPropertyObj.crsOwnerId;
                                    vm.selectedRuClientAccountList = vm.ruPropertyObj.rentalUnitedClient;
                                    vm.unitTypeData = vm.ruPropertyObj
                                }
                            }
                            // else {
                            //     vm.$store.dispatch("toastr", {
                            //         type: "error",
                            //         header: "Error",
                            //         message: "In getting unit type detail"
                            //     });
                            // }
                        }
                    }
                });
            },
            Get_UnitsAssociated_ToUnitType() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_UnitsAssociated_ToUnitType",
                    params: {
                        ModuleAction: "Get_UnitsAssociated_ToUnitType",
                        unitTypeId: vm.$route.params.unitTypeId,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Get_UnitsAssociated_ToUnitType", err);
                        }
                        if (response) {
                            console.log("response of Get_UnitsAssociated_ToUnitType", response);
                            if (response[0] && response[0].length > 0) {
                                vm.unitList = response[0];
                            }
                        }
                    }
                });
            },
            saveWeekdayRate() {
                let vm = this;
                if (vm.unitTypeData.UnitTypeId == null || vm.unitTypeData.UnitTypeId == -1 || vm.unitTypeData.UnitTypeId == undefined) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please save unit type info"
                    });
                    return;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitType_WeekdayCharges",
                    params: {
                        ModuleAction: "Save_UnitType_WeekdayCharges",
                        unitTypeData: vm.unitTypeData
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Save_UnitType_WeekdayCharges", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In saving weekday rate"
                            });
                        }
                        if (response) {
                            console.log("response of Save_UnitType_WeekdayCharges", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Weekday rate saved successfully"
                            });
                            vm.Get_UnitTypeDetail();
                        }
                    }
                });
            },
            saveWeekendRate() {
                let vm = this;
                if (vm.unitTypeData.UnitTypeId == null || vm.unitTypeData.UnitTypeId == -1 || vm.unitTypeData.UnitTypeId == undefined) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "",
                        message: "Please save unit type info"
                    });
                    return;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_UnitType_WeekendCharges",
                    params: {
                        ModuleAction: "Save_UnitType_WeekendCharges",
                        unitTypeData: vm.unitTypeData
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("error in Save_UnitType_WeekendCharges", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "In saving weekend rate"
                            });
                        }
                        if (response) {
                            console.log("response of Save_UnitType_WeekendCharges", response);
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Weekend rate saved successfully"
                            });
                            vm.Get_UnitTypeDetail();
                        }
                    }
                });
            },
            getCustomFields() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetCustomFields",
                    params: {
                        CustomEntityID: 3,
                    },
                    callback: function (err, response) {
                        if (response) {
                            vm.customFieldsList = response.recordsets[0];
                            console.log('GetCustomFields response', response);
                        } else {
                            console.log("GetCustomFields error", err);
                        }
                    }
                });
            },
            saveCustomFieldInstances() {
                let vm = this;
                vm.customFieldsList.forEach(currentField => {
                    console.log('currentField', currentField);
                    console.log('vm.$route.params.propertyId', vm.$route.params.propertyId);
                    if (vm.unitTypeData.UnitTypeId != -1) {
                        vm.$store.dispatch("dataRequestHandler", {
                            key: "SaveCustomFieldInstances",
                            params: {
                                CustomEntityID: currentField.CustomEntityID,
                                FieldID: currentField.FieldID,
                                FieldTypeID: currentField.FieldTypeID,
                                FieldTypeName: currentField.FieldTypeName,
                                FieldTypeValue: currentField.FieldTypeValue ? currentField.FieldTypeValue : "",
                                CustomFieldName: currentField.CustomFieldName,
                                PropertyID: vm.$route.params.propertyId,
                                UnitTypeID: vm.unitTypeData.UnitTypeId,
                                Config: "",
                            },
                            callback: function (err, response) {
                                if (response) {
                                    console.log('SaveCustomFieldInstances response:', response);
                                    // vm.getCustomFields();
                                    // vm.getCustomFieldInstances();
                                    vm.$store.dispatch("toastr", {
                                        type: "success",
                                        header: "Success",
                                        message: "Custom Fields Value Saved Successfully",
                                    });
                                } else {
                                    console.log("SaveCustomFieldInstances error", err);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        header: "Error",
                                        message: "Error while Saving Custom Fields Value",
                                    });
                                }
                            }
                        });
                    } else {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "Warning",
                            message: "Please Create UnitType"
                        });
                    }
                });
            },
            getCustomFieldInstances() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetCustomFieldInstances",
                    params: {
                        // ClientID: 5,
                        PropertyID: vm.$route.params.propertyId ? vm.$route.params.propertyId : null,
                        UnitTypeID: vm.$route.params.unitTypeId,
                        CustomEntityID: 3,
                    },
                    callback: function (err, response) {
                        if (response) {
                            console.log('GetCustomFieldInstances response', response);
                            let customFieldInstances = response.recordsets[0];
                            vm.customFieldsList.forEach(field => {
                                let instance = customFieldInstances.find(instance => instance.FieldID === field.FieldID);
                                field.FieldTypeValue = instance ? instance.FieldTypeValue : null;
                            });
                        } else {
                            console.log("GetCustomFieldInstances error", err);
                        }
                    }
                });
            },
            isInputType(fieldType) {
                return ['Number', 'String'].includes(fieldType);
            },
            getInputType(fieldType) {
                let vm = this;
                switch (fieldType) {
                    case 'Number':
                        vm.customFieldPlaceHolder = 'Enter Numeric Value';
                        return 'number';
                    case 'String':
                        vm.customFieldPlaceHolder = 'Enter Custom Field Value';
                        return 'text';
                    default:
                        vm.customFieldPlaceHolder = 'Enter Custom Field Value';
                        return 'text';
                }
            },
            parseLovJSON(value) {
                try {
                    return JSON.parse(value);
                } catch {
                    return [];
                }
            },
            parsedLovConfig(config) {
                return JSON.parse(config);
            },
            filteredListofValues(list) {
                let vm = this;
                const selectedValues = vm.parseLovJSON(list.FieldTypeValue) || [];
                const listOfValues = vm.parsedLovConfig(list.Config).ListOfValues || [];
                return listOfValues.filter(value => !selectedValues.includes(value.value) && (value.statusId !== -1 && value.statusId !== -2));
            },
            initializeShowLovList(fieldID) {
                if (typeof this.showLovList !== 'object') {
                    this.showLovList = {};
                }
                if (!(fieldID in this.showLovList)) {
                    this.$set(this.showLovList, fieldID, false);
                }
            },
            showLovListFnc(fieldID) {
                this.selectedLovDropdown = fieldID
                this.initializeShowLovList(fieldID);
                this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
                setTimeout(() => {
                    $("#Lovsdropdowns-" + fieldID).show();
                }, 10);
            },
            toggleDropdown(fieldID) {
                this.initializeShowLovList(fieldID);
                this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
            },
            removeListOfValues(fieldID, index) {
                let vm = this;
                const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
                if (list && Array.isArray(vm.parseLovJSON(list.FieldTypeValue))) {
                    const parsedValue = vm.parseLovJSON(list.FieldTypeValue);
                    parsedValue.splice(index, 1);
                    list.FieldTypeValue = JSON.stringify(parsedValue) == '[]' ? '' : JSON.stringify(parsedValue);
                }
                vm.showLovListFnc(fieldID);
            },
            addListOfValues(fieldID, value) {
                let vm = this;
                const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
                if (list) {
                    let parsedValue = vm.parseLovJSON(list.FieldTypeValue);
                    if (!Array.isArray(parsedValue)) {
                        parsedValue = [];
                    }
                    parsedValue.push(value.value);
                    list.FieldTypeValue = JSON.stringify(parsedValue);
                }
                vm.showLovListFnc(fieldID);
            },
            updateCustomFieldDate(key, dateObj, list) {
                const field = this.customFieldsList.find(field => field.FieldID === list.FieldID);
                if (field) {
                    field.FieldTypeValue = dateObj ? dateObj.format("DD MMM YYYY") : null;
                }
            },
            formatFieldTypeValue(value) {
                if (!value) {
                    return '';
                }
                if (value.startsWith('["') && value.endsWith('"]')) {
                    return value.slice(2, -2).split('","').join(',');
                }
                return value;
            }
        },

        computed: {},

        watch: {
            componentIntegrationId() {
                this.Get_PaymentAccount_Details();
            },
        },
        created() { },
        mounted() {
            let vm = this;
            vm.getPropertyMetaData();
            vm.Get_UnitTypeDetail();
            vm.getImages()
            vm.Get_ListOfIntegrations();
            vm.getCustomFields();
            vm.getCustomFieldInstances();
            $(document).click(function (e) {
                $("#Lovsdropdowns-" + vm.selectedLovDropdown).hide();
            });
        }
    };
</script>
<style>
    .disabled_customField_class {
        pointer-events: none;
        opacity: 0.5;
    }
</style>